import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const points = ['Terminas el día agotado pero sin haber descansado de verdad', 'Tu mente sigue abierta después del trabajo — bucles que no paran', 'Procrastinas decisiones porque estás mentalmente saturado', 'Te vas a dormir con 20 pestañas abiertas en la cabeza', 'El móvil te roba tiempo pero no te da descanso real', 'Los fines de semana no recargas — empiezas el lunes ya vacío', 'Llevas meses así y no sabes cómo salir del ciclo'];
  return <Section data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 leading-tight" data-id="element-134">
          ¿Cuántas noches más vas a irte a dormir con la{' '}
          <span className="text-brand-accent" data-id="element-135">cabeza llena?</span>
        </h2>

        <p className="text-lg text-neutral-300 text-center mb-6 leading-relaxed" data-id="element-136">
          Amás lo que hacés, pero terminás el día con la cabeza a mil, sin poder
          desconectar, mirando el techo pensando en todo lo que quedó sin
          resolver.
        </p>

        <div className="text-center mb-12" data-id="element-137">
          <span className="inline-block bg-brand-accent/10 text-brand-accent font-bold px-6 py-3 rounded-lg text-xl border border-brand-accent/20" data-id="element-138">
            No es debilidad. Es falta de un sistema.
          </span>
        </div>

        <div className="bg-brand-card border border-neutral-800 rounded-2xl p-8 md:p-10 mb-12" data-id="element-139">
          <ul className="space-y-5" data-id="element-140">
            {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-141">
                <span className="text-red-500 text-xl mt-0.5 shrink-0" data-id="element-142">❌</span>
                <span className="text-lg text-neutral-300" data-id="element-143">{point}</span>
              </li>)}
          </ul>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-144">
          ¿Y si esta fuera la última noche que pasás así?
        </h3>
      </div>
    </Section>;
}